import { Component, Input, OnInit } from '@angular/core';
import { PaymentData } from 'src/app/modules/shared/models/payment.model';
import { Product } from 'src/app/modules/shared/models/products.model';

@Component({
  selector: 'product-details-mobile',
  templateUrl: './product-details-mobile.component.html',
  styleUrls: ['./product-details-mobile.component.scss'],
})
export class ProductDetailsMobileComponent implements OnInit {
  @Input() product: Product;
  paymentData: PaymentData;
  priceLabel: string;

  ngOnInit(): void {
    this.priceLabel = `${this.product?.currency_detail?.symbol}${+this.product
      .store_product_detail.store_varieties[0].variety_detail.min_price}`;
  }

  handlePaymentBoxData(data: PaymentData) {
    this.paymentData = data;
  }
}
